import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import responsiveStyles from "./responsiveStyles.module.scss";
import { Wrapper } from "../../reusable";
import { CardStack } from "../../ui/card-stack";
import profile from "../../../assets/profile.png";
import tick from "../../../assets/white-tick.png";

function WhoCanSignUp() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check on mount
    checkMobile();

    // Add event listener
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const cards = [
    {
      id: 1,
      name: "Took a weight‑loss drug",
      designation: "Eligible",
      content: (
        <div>
          <div
            style={{
              height: "44px",
              width: "44px",
              borderRadius: "12px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f4faff",
              border: "1px solid #e4f0fb",
              marginBottom: "12px",
            }}
          >
            <img src={tick} alt="Eligible" style={{ height: "24px" }} />
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Took a weight‑loss drug
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            Used Ozempic, Wegovy, Mounjaro or similar prescribed by NHS or
            private provider.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      name: "Had side effects or complications",
      designation: "Eligible",
      content: (
        <div>
          <div
            style={{
              height: "44px",
              width: "44px",
              borderRadius: "12px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f4faff",
              border: "1px solid #e4f0fb",
              marginBottom: "12px",
            }}
          >
            <img src={tick} alt="Eligible" style={{ height: "24px" }} />
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Had side effects or complications
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            Experienced severe nausea, pancreatitis, gallbladder issues or other
            complications.
          </p>
        </div>
      ),
    },
    {
      id: 3,
      name: "Not sure if you qualify?",
      designation: "Check eligibility",
      content: (
        <div>
          <div
            style={{
              height: "44px",
              width: "44px",
              borderRadius: "12px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f4faff",
              border: "1px solid #e4f0fb",
              marginBottom: "12px",
            }}
          >
            <img
              src={tick}
              alt="Check eligibility"
              style={{ height: "24px" }}
            />
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Not sure if you qualify?
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            We'll review your medical history and advise if you may have a
            malpractice claim.
          </p>
        </div>
      ),
    },
  ];

  return (
    <section className={`${styles.section} ${responsiveStyles.section}`}>
      <Wrapper>
        <div className={`${styles.inner} ${responsiveStyles.inner}`}>
          <div className={styles.header}>
            <h2>Who can sign up</h2>
            <img src={profile} alt="Eligibility" />
          </div>

          {/* Desktop: Show original grid layout */}
          <div
            className={`${styles.grid} ${responsiveStyles.grid}`}
            style={{ display: isMobile ? "none" : "grid" }}
          >
            <div className={styles.item}>
              <div className={styles.icon}>
                <img src={tick} alt="" />
              </div>
              <div className={styles.content}>
                <span className={styles.badge}>Eligible</span>
                <h3>Took a weight‑loss drug</h3>
                <p>
                  Used Ozempic, Wegovy, Mounjaro or similar prescribed by NHS or
                  private provider.
                </p>
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.icon}>
                <img src={tick} alt="" />
              </div>
              <div className={styles.content}>
                <span className={styles.badge}>Eligible</span>
                <h3>Had side effects or complications</h3>
                <p>
                  Experienced severe nausea, pancreatitis, gallbladder issues or
                  other complications.
                </p>
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.icon}>
                <img src={tick} alt="" />
              </div>
              <div className={styles.content}>
                <span className={styles.badgeAlt}>Check eligibility</span>
                <h3>Not sure if you qualify?</h3>
                <p>
                  We'll review your medical history and advise if you may have a
                  malpractice claim.
                </p>
              </div>
            </div>
          </div>

          {/* Mobile: Show CardStack */}
          {isMobile && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginTop: "20px",
              }}
            >
              <CardStack
                items={cards}
                offset={15}
                scaleFactor={0.08}
                containerClassName="h-72 md:h-72"
                cardClassName="h-72 md:h-72"
              />
            </div>
          )}
        </div>
      </Wrapper>
    </section>
  );
}

export default WhoCanSignUp;
